import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latest = articles.slice(0, 4);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 animate-slide-up">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-100">影视资讯</h2>
          <p className="text-foreground-500 text-sm mt-1">最新影视动态与深度影评</p>
        </div>
        <Link
          to="/category/all"
          className="text-primary-400 text-sm hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
        >
          更多资讯
          <div className="w-4 h-4 inline-flex items-center justify-center ml-1">
            <i className="ri-arrow-right-line"></i>
          </div>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {latest.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}